import { temperature, speed, getSizes } from '../helpers/helpers'; 

const counterContainers = document.querySelectorAll('.counter');

counterContainers.forEach(counter => {
  const getIncrement = counter.querySelector('.increment');
  const getDecrement = counter.querySelector('.decrement');
  const input = counter.querySelector('input[type="number"]');
  const getClimate = document.querySelector('#climateButton');
  
  const checkLimits = () => {
    getIncrement.disabled = input.value >= parseInt(input.max);
    getDecrement.disabled = input.value <= parseInt(input.min);
    
    if (temperature.value >= temperature.min && temperature.value < (temperature.max / 2)) {
      getClimate.setAttribute('heating', 'on');
    } else {
      getClimate.setAttribute('heating', 'off');
    }

    if (temperature.value >= (temperature.max / 2) && temperature.value <= temperature.max) {
      getClimate.setAttribute('ac', 'on');
    } else {
      getClimate.setAttribute('ac', 'off');
    }
  };

  getIncrement.addEventListener('click', () => {
    input.stepUp(1);
    input.setAttribute('value', input.value);
    getSizes.forEach(wheelSpeed => {
      wheelSpeed.setAttribute('speed', speed.value);
    });
    checkLimits();
  });

  getDecrement.addEventListener('click', () => {
    input.stepDown(1);
    input.setAttribute('value', input.value);
    getSizes.forEach(wheelSpeed => {
      wheelSpeed.setAttribute('speed', speed.value);
    });
    checkLimits();
  });
});
